























































import User from '@/datatypes/user';
import EnterpriseService from '@/services/enterprise/EnterpriseService';
import EnterpriseCreateRequest from '@/datatypes/enterprise/create-request';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';
import Vue from 'vue';

export default Vue.extend({
  data: () => ({
    hasNext: true,
    user: new User({}),
    errorMessage: '',
    enterpriseService: new EnterpriseService(),
    newBusiness: new EnterpriseCreateRequest({}),
    isCreatingBusiness: false,
  }),

  components: {
    SnackbarMessageHandler,
  },

  methods: {
    createBusiness() {
      this.enterpriseService.create(this.newBusiness).then((response) => {
        this.$router.push(`/businesses/${response.data.id}`);
      }).catch((error) => {
        this.errorMessage = error.response.data.message;
      });
    },
  },
});
